var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMovePick = function SvgMovePick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    d: "M11.5 8.5 8.854 5.854a.5.5 0 0 0-.708 0L5.5 8.5m7 7 2.646 2.646a.5.5 0 0 0 .708 0L18.5 15.5m-10 3v-12m7-1v12"
  })));
};
export { SvgMovePick as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiPjxwYXRoIGQ9Ik0xMS41IDguNSA4Ljg1MzU1IDUuODUzNTVjLS4xOTUyNi0uMTk1MjYtLjUxMTg0LS4xOTUyNi0uNzA3MSAwTDUuNSA4LjVNMTIuNSAxNS41bDIuNjQ2NCAyLjY0NjRjLjE5NTMuMTk1My41MTE5LjE5NTMuNzA3MiAwTDE4LjUgMTUuNU04LjUgMTguNXYtMTJNMTUuNSA1LjV2MTIiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+PC9zdmc+";